import styled from "styled-components";

const BookingActions = styled.div`
  display: grid;
  gap: 12px;
  width: 280px;
  max-width: 100%;
  margin: 20px auto;

  .ant-btn > .ant-btn-loading-icon {
    position: absolute;
    left: 16px;
    width: auto;
    margin-left: 0;
  }

  .ant-btn > .ant-btn-loading-icon + span {
    margin-left: 0;
  }
`;

export default BookingActions;
